{
    "UserMenu_Notifications": "Benachrichtigungen",
    "UserMenu_UserTour": "Benutzerschulungstour starten",
    "UserMenu_ShowInsights": "Insights-Dashboard anzeigen",
    "UserMenu_HideInsights": "Insights-Dashboard ausblenden",
    "UserMenu_ChangePassword": "Kennwort ändern",
    "UserMenu_ChangeLanguage": "Sprache ändern",
    "UserMenu_Timezone": "Zeitzone ändern",
    "UserMenu_Help": "Helfen",
    "UserMenu_ClearContentful": "Contentful Cache leeren",
    "UserMenu_ChangeBrowserProfile": "Browserprofil ändern",
    "UserMenu_Resources": "Ressourcen",
    "UserMenu_Resources_Terms": "Allgemeine Geschäftsbedingungen",
    "UserMenu_Resources_CookiePolicy": "Cookie-Richtlinie",
    "UserMenu_Resources_PrivacyPolicy": "Datenschutzrichtlinie",
    "UserMenu_Logout": "Ausloggen",
    "NAME": "UserMenu"
}